<template>
  <div class="portfolio">
    <h2 class="title">portfolio.</h2>
    <div class="portfolio-content">
      <button @click="onSiemaPrev"><img class="prev" src="@/assets/arrow.svg" alt="Previous" /></button>
      <div class="siema wow fadeIn animated">
          <div>
            <a class="gh-link" href="https://github.com/cindychea/papical-back-end"><img class="port-img" src="@/assets/papical.png" alt="Papical" /></a>
          </div>
          <div>
            <a class="gh-link" href="https://github.com/cindychea/crowdfunder"><img class="port-img" src="@/assets/crowdfunder.png" alt="Crowdfunder" /></a>
          </div>
          <div>
            <a class="gh-link" href="https://github.com/cindychea"><img class="port-img" src="@/assets/github.png" alt="Github" /></a>
          </div>
      </div>
      <button @click="onSiemaNext"><img class="next" src="@/assets/arrow.svg" alt="Next" /></button>
    </div>
  </div>


</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Siema from 'siema';
import { setInterval, clearInterval } from 'timers';

export default {
  name: 'portfolio',
  components: {
    HelloWorld
  },
  data() {
    return {
      siema: null,
    }
  },
  mounted() {
    this.$data.siema = new Siema({
      selector: '.siema',
      duration: 400,
      easing: 'ease-in-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: true,
      rtl: false,
      onInit: () => {},
      onChange: () => {
        // clearInterval(carouselInterval)
      },
    });
    // var carouselInterval = setInterval(() => {
    //   this.siema.next()
    // }, 8000);
  },
  methods: {
    onSiemaPrev() {
      this.siema.prev()
    },
    onSiemaNext() {
      this.siema.next()
    },
  },
}
</script>

<style lang="scss" scoped>
.portfolio {
  min-height: 100vh;
  width: 100%;
  .portfolio-content {
    max-width: 1200px;
    max-height: 600px;
    overflow: auto;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    // align-items: center;
    // justify-content: center;
  }
  .siema {
    width: 100%;
    height: auto;
    margin: 10px 40px;
    overflow: scroll;
    font-family: 'Raleway', sans-serif;
    .gh-link {
      width: 100%;
    }
    .port-img {
      width: 100%;
    }
  }
  button {
    border: none;
    .next {
      -moz-transform: scaleX(-1);
      -o-transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
      transform: scaleX(-1);
    }
  }
}
</style>